import React from "react"
import PropTypes from "prop-types"
import { Button } from "./Button"
import Link from "./Link"

const CtaButton = ({
  as,
  to,
  title,
  size,
  smSize,
  className = "convert convert-line",
  type,
}) => {
  return (
    <Link as={as} to={to}>
      <div className="sm:hidden">
        <Button
          className={`convert convert-line ${className}`}
          size={size}
          type={type}
        >
          {title}
        </Button>
      </div>
      <div className="hidden sm:block">
        <Button
          className={`convert convert-line ${className}`}
          size={smSize}
          type={type}
        >
          {title}
        </Button>
      </div>
    </Link>
  )
}

CtaButton.propTypes = {
  as: PropTypes.string,
  to: PropTypes.string,
  title: PropTypes.string,
  size: PropTypes.string,
  smSize: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
}

export default CtaButton
